import { ClearFeeEarnerRateResponseSchema, FeeEarnerRateSchema, ListFeeEarnerRatesResponseSchema, } from '@packages/types';
import { api } from '../client.js';
export function listClientFeeEarnerRates(accountId, clientId) {
    return api(`/accounts/${accountId}/clients/${clientId}/fee-earner-rates`, ListFeeEarnerRatesResponseSchema);
}
export function setClientFeeEarnerRate(accountId, clientId, membershipId, input) {
    return api(`/accounts/${accountId}/clients/${clientId}/fee-earner-rates/${membershipId}`, FeeEarnerRateSchema, {
        method: 'PUT',
        body: input,
    });
}
export function clearClientFeeEarnerRate(accountId, clientId, membershipId) {
    return api(`/accounts/${accountId}/clients/${clientId}/fee-earner-rates/${membershipId}`, ClearFeeEarnerRateResponseSchema, {
        method: 'DELETE',
    });
}
export function listClientProjectFeeEarnerRates(accountId, clientProjectId) {
    return api(`/accounts/${accountId}/client-projects/${clientProjectId}/fee-earner-rates`, ListFeeEarnerRatesResponseSchema);
}
export function setClientProjectFeeEarnerRate(accountId, clientProjectId, membershipId, input) {
    return api(`/accounts/${accountId}/client-projects/${clientProjectId}/fee-earner-rates/${membershipId}`, FeeEarnerRateSchema, { method: 'PUT', body: input });
}
export function clearClientProjectFeeEarnerRate(accountId, clientProjectId, membershipId) {
    return api(`/accounts/${accountId}/client-projects/${clientProjectId}/fee-earner-rates/${membershipId}`, ClearFeeEarnerRateResponseSchema, { method: 'DELETE' });
}
